const REFERENCE_ASSETS = require('../reference-assets.json');

module.exports = {
    busd: {
        id: 'busd',
        type: REFERENCE_ASSETS.USD,
        symbol: 'BUSD',
        decimals: 1e18,
        address: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
    },
    usdc: {
        id: 'usdc',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDC',
        decimals: 1e18,
        address: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
    },
    usdt: {
        id: 'usdt',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDT',
        decimals: 1e18,
        address: '0x55d398326f99059ff775485246999027b3197955',
    },
    trieps: {
        id: 'trieps',
        type: REFERENCE_ASSETS.USD,
        symbol: '3Eps',
        decimals: 1e18,
        address: '0xaf4de8e872131ae328ce21d909c74705d3aaf452',
        isLpToken: true,
    },
    fusdt: {
        id: 'fusdt',
        type: REFERENCE_ASSETS.USD,
        symbol: 'fUSDT',
        decimals: 1e6,
        address: '0x049d68029688eabf473097a2fc38ef61633a3c7a',
    },
    btcb: {
        id: 'btcb',
        type: REFERENCE_ASSETS.BTC,
        symbol: 'BTCB',
        decimals: 1e18,
        address: '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
    },
    renbtc: {
        id: 'renbtc',
        type: REFERENCE_ASSETS.BTC,
        symbol: 'renBTC',
        decimals: 1e8,
        address: '0xfce146bf3146100cfe5db4129cf6c82b0ef4ad8c',
    },
    dai: {
        id: 'dai',
        type: REFERENCE_ASSETS.USD,
        symbol: 'DAI',
        decimals: 1e18,
        address: '0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3',
    },
    tusd: {
        id: 'tusd',
        type: REFERENCE_ASSETS.USD,
        symbol: 'TUSD',
        decimals: 1e18,
        address: '0x14016E85a25aeb13065688cAFB43044C2ef86784',
    },

};

// '0x48E9286Ce037f39fd4AC26D493faa39e9e2bc7eE',
// '0x921eEe40B78b597c2f0c5decC191BFD8D71D102e',
// '0xA9F0Ef4A8113E641E5b12D6270936c01F039987D',
